/**
 * PageMeta — ustawia per-podstrona: title, meta description, canonical,
 * Open Graph (og:title, og:description, og:url) i Twitter Card.
 * Wymaga HelmetProvider w App.tsx.
 *
 * WAŻNE: każdy tag ma atrybut `key` — react-helmet-async używa go do
 * deduplikacji tagów przy nawigacji SPA. Bez `key` stary tag zostaje
 * w <head> obok nowego, co powoduje podwójny canonical.
 */
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Kajaki Kudłaty Cooky";
const BASE_URL = "https://kajakikudlatycooky.pl";
const OG_IMAGE = `${BASE_URL}/manus-storage/hero_river_1920x1080_q30_95bd3bfa.webp`;

interface PageMetaProps {
  title: string;
  description: string;
  canonical: string;
  noindex?: boolean;
}

export default function PageMeta({ title, description, canonical, noindex = false }: PageMetaProps) {
  const fullUrl = `${BASE_URL}${canonical}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta key="description" name="description" content={description} />
      <link key="canonical" rel="canonical" href={fullUrl} />
      {noindex ? (
        <meta key="robots" name="robots" content="noindex, follow" />
      ) : (
        <meta key="robots" name="robots" content="index, follow" />
      )}
      {/* Open Graph */}
      <meta key="og:type" property="og:type" content="website" />
      <meta key="og:title" property="og:title" content={title} />
      <meta key="og:description" property="og:description" content={description} />
      <meta key="og:url" property="og:url" content={fullUrl} />
      <meta key="og:site_name" property="og:site_name" content={SITE_NAME} />
      <meta key="og:locale" property="og:locale" content="pl_PL" />
      <meta key="og:image" property="og:image" content={OG_IMAGE} />
      <meta key="og:image:width" property="og:image:width" content="1920" />
      <meta key="og:image:height" property="og:image:height" content="1080" />
      {/* Twitter Card */}
      <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
      <meta key="twitter:title" name="twitter:title" content={title} />
      <meta key="twitter:description" name="twitter:description" content={description} />
      <meta key="twitter:image" name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
